import { useRef, useState } from "react";
import { toast } from "sonner";
import { Camera, Loader2 } from "lucide-react";
import { readPlateFromFile } from "@/lib/plateOcr";

export function PlateCameraButton({ onRead, testid = "plate-camera" }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) { return; }
    setBusy(true);
    try {
      const plate = await readPlateFromFile(file);
      if (plate) { onRead(plate); toast.success(`Placa lida: ${plate} — confira antes de salvar`); }
      else { toast.error("Não consegui ler a placa, digite manualmente"); }
    } catch {
      toast.error("Não consegui ler a placa, digite manualmente");
    } finally { setBusy(false); }
  };
  return (
    <>
      <button type="button" data-testid={testid} disabled={busy} onClick={() => ref.current?.click()} aria-label="Ler placa pela câmera" title="Ler placa pela câmera"
        className="h-10 w-11 shrink-0 rounded-md border border-zinc-800 bg-zinc-900 text-green-300 inline-flex items-center justify-center hover:bg-zinc-800 disabled:opacity-60 transition-colors">
        {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : <Camera className="h-5 w-5" />}
      </button>
      <input ref={ref} data-testid={`${testid}-input`} type="file" accept="image/*" capture="environment" className="hidden" onChange={pick} />
      {busy && <span data-testid={`${testid}-reading`} className="sr-only">Lendo placa…</span>}
    </>
  );
}
